import { Routes } from "@angular/router";
import { AuthGuard } from "./generics/guard/auth.guard";
import { AdminLayoutComponent } from "./Template/layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./Template/layouts/auth/auth-layout.component";

export const AppRoutes: Routes = [
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./Template/pages/pages.module").then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "shelter-management",
        loadChildren: () =>
          import("./shelter-management/shelter-management.module").then(
            (m) => m.ShelterManagementModule
          ),
      },
      {
        path: "user-management",
        loadChildren: () =>
          import("./user-management/user-management.module").then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: "corporate-management",
        loadChildren: () =>
          import("./corporate-management/corporate-management.module").then(
            (m) => m.CorporateManagementModule
          ),
      },
      {
        path: "purchasing",
        loadChildren: () =>
          import("./purchasing/purchasing.module").then(
            (m) => m.PurchasingModule
          ),
      },
      {
        path: "invoicing",
        loadChildren: () =>
          import("./invoicing/invoicing.module").then((m) => m.InvoicingModule),
      },
      {
        path: "clients",
        loadChildren: () =>
          import("./clients/clients.module").then((m) => m.ClientsModule),
      },
      {
        path: "suppliers",
        loadChildren: () =>
          import("./suppliers/suppliers.module").then((m) => m.SuppliersModule),
      },
      {
        path: "repse",
        loadChildren: () =>
          import("./repse/repse.module").then((m) => m.RepseModule),
      },
      {
        path: "ivemsa-connect",
        loadChildren: () =>
          import("./ivemsa-connect/ivemsa-connect.module").then(
            (m) => m.IvemsaConnectModule
          ),
      },
      {
        path: "user",
        loadChildren: () =>
          import("./Template/userpage/user.module").then((m) => m.UserModule),
      },
      {
        path: "debts-to-pay",
        loadChildren: () =>
          import("./debts-to-pay-management/debts-to-pay.module").then(
            (m) => m.DebtsToPayModule
          ),
      },
      {
        path: "reports",
        loadChildren: () =>
          import("./reports-management/report-management.module").then(
            (m) => m.ReportManagementModule
          ),
      },
      {
        path: "catalogs",
        loadChildren: () =>
          import("./catalogs/catalogs.module").then((m) => m.CatalogsModule),
      },
      {
        path: "customer",
        loadChildren: () =>
          import("./customer/customer.module").then((m) => m.CustomerModule),
      },
    ],
  },
];
